import React, { useEffect, useState } from "react";
import { getApiData } from "../../services/index";
import "./index.css";
import { Helmet } from "react-helmet";

const About = () => {
  const [about, setAbout] = useState({});
  const [loading, setLoading] = useState(true); // Loading state
  const [metaTitle, setMetaTitle] = useState("");
  const [metaKeywords, setMetaKeywords] = useState("");
  const [metaDescription, setMetaDescription] = useState("");

  const checkData = async () => {
    const app = {};
    try {
      const result = await getApiData("api/get_our_story", app);
      if (result?.status === 200 && result.data?.length) {
        const introductionData = result.data[0]; // Ensure data exists
        setAbout(introductionData);
        setMetaTitle(introductionData.meta_title);
        setMetaKeywords(introductionData.meta_keyword);
        setMetaDescription(introductionData.meta_description);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false); // Ensures loading 1 set to false in all cases
    }
  };

  useEffect(() => {
    checkData();
  }, []);

  if (loading) {
    // Loading indicator
    return <p>Loading...</p>;
  }

  return (
    <>
      <Helmet>
        <meta name="title" content={metaTitle} />
        <meta name="description" content={metaDescription} />
        <meta name="keywords" content={metaKeywords} />
      </Helmet>
      {/* main section */}
      <section>
        <div className="p-4 max-w-7xl mx-auto">
          {/* Hero Section */}
          <section className="mt-8">
            <div className="container" style={{ zIndex: 0 }}>
              <div className="ceo-grid-2 no-gap">
                <div id="w-node-d44cd5a9-f968-a640-bb6d-b50b5f3db574-4b337b90">
                  <div className="image-wrapper">
                    <img
                      src={about.about_image}
                      loading="eager"
                      alt={about.about_title1}
                      className="cover-animated-image cover-animated-image-mob ceo-grid-about w-full h-auto"
                    />
                  </div>
                </div>
                <div id="w-node-d44cd5a9-f968-a640-bb6d-b50b5f3db578-4b337b90">
                  <div className="flex-tag left">
                    <div className="bullet-tag"></div>
                  </div>
                  <div>
                    <h2 className="text-2xl font-semibold mb-4">
                      {about.about_title1}{" "}
                      <span style={{ color: "#4BBA89" }}>
                        {about.about_title2}
                      </span>
                    </h2>
                    <div>
                      <p
                        className="subhead text-justify"
                        dangerouslySetInnerHTML={{
                          __html: about.about_desc,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="mt-12">
            <div className="container">
              <div className="cta-grid">
                <div id="w-node-_86b659df-b93d-dfa6-9d4f-1ba273b772a1-b3f3b9f1">
                  <div className="flex-tag left">
                    <div className="bullet-tag color"></div>
                  </div>
                  <h2 className="text-2xl font-semibold mb-4">
                    {about.why_title1}{" "}
                    <span style={{ color: "#4BBA89" }}>{about.why_title2}</span>
                  </h2>
                  <div className="text-justify">
                    <p
                      className="subhead sm:mt-5"
                      dangerouslySetInnerHTML={{
                        __html: about.why_desc,
                      }}
                    />
                  </div>
                  <div className="margin-50px"></div>
                </div>
                <div className="image-wrapper">
                  <img
                    src={about.why_image}
                    loading="eager"
                    alt={about.why_title1}
                    className="cover-animated-image cover-animated-image-mob w-full h-auto"
                  />
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>

      {/* Vision and Mission */}
      <section>
        <div className="p-4 max-w-7xl mx-auto">
          <section className="mt-8">
            <h1
              className="text-3xl font-semibold text-center mb-8"
              dangerouslySetInnerHTML={{
                __html: about.visomiso_head,
              }}
            ></h1>

            {/* Vision Section */}
            <section className="bg-[#FFFBF6] p-6 rounded-lg">
              <h2 className="text-2xl font-semibold text-center text-[#4BBA89] mb-4">
                {about.vision_title}
              </h2>
              <p
                className="subhead text-justify"
                dangerouslySetInnerHTML={{
                  __html: about.vision_desc,
                }}
              />
            </section>

            {/* Mission Section */}
            <section className="bg-[#FFFBF6] p-6 rounded-lg mt-8">
              <h2 className="text-2xl font-semibold text-center text-[#4BBA89] mb-4">
                {about.mission_title}
              </h2>
              <p
                className="subhead text-justify"
                dangerouslySetInnerHTML={{
                  __html: about.mission_desc,
                }}
              />
            </section>
          </section>
        </div>
      </section>

      {/* Our Values Section */}
      <section>
        <div className="p-4 max-w-7xl mx-auto">
          <section className="mt-8">
            <h1 className="text-3xl font-semibold text-center mb-8">
              {about.values_head}
            </h1>

            <section className="bg-[#FFFBF6] p-6 rounded-lg">
              <h2 className="text-2xl font-semibold text-center text-[#4BBA89] mb-4">
                {about.values_title}
              </h2>
              <p
                className="subhead text-justify"
                dangerouslySetInnerHTML={{
                  __html: about.values_desc,
                }}
              />
            </section>
          </section>
        </div>
      </section>

      {/* Quote */}
      <p className="main-display text-center">{about.quote}</p>
    </>
  );
};

export default About;
